import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const deleteFeaturePreview = (featureId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETING_FEATURE_PREVIEW' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.delete(`/ads/link-tokens/${featureId}`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'DELETING_FEATURE_PREVIEW_DONE',
              payload: {
                document: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'DELETING_FEATURE_PREVIEW_FAILED',
              payload: `Failed to delete feature preview`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'DELETING_FEATURE_PREVIEW_FAILED',
            payload: `Failed to delete feature preview`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'DELETING_FEATURE_PREVIEW_FAILED',
        payload: `Failed to delete feature preview`,
      });
    }
  };
};

export default deleteFeaturePreview;
